import { useState } from "react";
import { seedCollection } from "../../services/firestoreService";
import { toast } from "sonner";
import { Button } from "../ui/button";

export default function SeedDataButton({ collectionName, data, onComplete, isEmpty }) {
  const [loading, setLoading] = useState(false);

  // Hanya tampil jika data masih kosong
  if (isEmpty === false) return null;
  const handleSeed = async () => {
    setLoading(true);
    try {
      await seedCollection(collectionName, data);
      toast.success(`Contoh data berhasil dibuat!`);
      onComplete?.();
    } catch (err) {
      toast.error(err.message);
    } finally {
      setLoading(false);
    }
  };
  return (
    <Button
      variant="outline"
      onClick={handleSeed}
      disabled={loading}
      className="border-[#d4af37]/30 text-[#d4af37]"
    >
      {loading ? "Memuat..." : "Buatkan Contoh"}
    </Button>
  );
}
